import logScope from 'log-scope'
const log = logScope('query')

export default {
  methods: {
    __replaceQuery (q, value) {
      this.$router
        .replace({
          query: {
            ...this.$route.query,
            [q]: value,
          },
        })
        .catch(err => {
          // Ignore the error regarding navigating to page we are already on
          if (
            err.name !== 'NavigationDuplicated' &&
            !err.message.includes(
              'Avoided redundant navigation to current location'
            )
          ) {
            // Log any other errors
            log(err)
          }
        })
    },
    __pushQuery (q, value) {
      // No need to catch any errors here since route always differ
      this.$router.push({
        query: {
          ...this.$route.query,
          [q]: value,
        },
      })
    },
    __removeQuery (q) {
      let query = Object.assign({}, this.$route.query)
      delete query[q]
      this.$router.push({ query })
    },
  },
}
